export default __webpack_public_path__ + "static/media/infoYellow.b4e519d1.svg";